import { type AiModelPricing } from '@aysar/contracts';
import { useTranslation } from 'react-i18next';

import { DynamicFormModal } from '@/shared/components/dynamic-form/DynamicFormModal/DynamicFormModal';
import { type ModalComponentProps } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { useAiRateEditorModalLogic } from './useAiRateEditorModalLogic';

/**
 * One model's four rates.
 *
 * Presentation only; every decision — the refusal, the `dangerous`
 * confirmation, the fallback prefill, the loading hold — is in
 * `useAiRateEditorModalLogic` (U5). `ProviderConfigModal` beside it still keeps
 * its logic in the body; that is debt, not a precedent to follow.
 */
export function AiRateEditorModal({ open, onCancel, modalData }: ModalComponentProps) {
  const { t } = useTranslation('integrations');

  const settingKey = typeof modalData?.['key'] === 'string' ? modalData['key'] : '';
  const view = useAiRateEditorModalLogic({
    settingKey,
    label: typeof modalData?.['label'] === 'string' ? modalData['label'] : settingKey,
    capability: typeof modalData?.['capability'] === 'string' ? modalData['capability'] : '',
    onDone: onCancel,
  });

  return (
    <DynamicFormModal<AiModelPricing>
      isOpen={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onCancel();
      }}
      title={view.title}
      description={t('rates.edit.hint')}
      size="md"
      isLoading={view.isLoading}
      fields={view.fields}
      schema={view.schema}
      initialValues={view.initialValues}
      submitLabel={t('rates.edit.save')}
      onCancel={onCancel}
      onSubmit={view.submit}
    />
  );
}
